/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExcel,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import LoadingModal from '../../components/LoadingModal';
import {
  cattleAndMilkingReport,
  appointmentsReport,
  consultationReport,
  feedbackReport,
  usersReport,
  milkSlipsReport,
  feedReport,
  cattleMilkingReport,
  uninstalledReport,
  digitalRegistrationsReport,
  loanRequestReport,
  generateReportForMcc,
  deregistrationRequestsReport,
  farmerProfilingReport,
} from '../../store/modules/user/actions';
import {
  exportPlantOrders,
} from '../../store/modules/order/actions';
import {
  regionsReport,
} from '../../store/modules/data/actions';
import {
  exportRegionalHeadManualIndent,
} from '../../store/modules/product/actions';
import { selectIsLoadingExport } from '../../store/modules/user/selectors';
import { selectIsLoadingExport as selectIsLoadingExportOrders } from '../../store/modules/order/selectors';
import { selectIsLoadingExport as selectIsLoadingExportRegions } from '../../store/modules/data/selectors';
import { selectIsLoadingExport as selectIsLoadingExportProducts } from '../../store/modules/product/selectors';

import './Reports.scss';

const Reports = () => {
  const dispatch = useDispatch();
  const isExporting = useSelector((state) => selectIsLoadingExport(state));
  const isExportingOrders = useSelector((state) => selectIsLoadingExportOrders(state));
  const isExportingRegions = useSelector((state) => selectIsLoadingExportRegions(state));
  const isExportingProducts = useSelector((state) => selectIsLoadingExportProducts(state));
  const role = localStorage.getItem('role');
  const email = (localStorage.getItem('email') || '').toLowerCase();
  const canAccessDeregistrationRequests = role === 'admin' && email === 'admin@heritagevetplus.com';
  const exportFarmers = () => {
    dispatch(usersReport());
  };

  const exportCattle = () => {
    dispatch(cattleAndMilkingReport());
  };

  const exportFarmerProfiling = () => {
    dispatch(farmerProfilingReport());
  };

  const exportCattleMilking = () => {
    dispatch(cattleMilkingReport());
  };

  const exportMilkSlips = () => {
    dispatch(milkSlipsReport());
  };

  const exportFeedback = () => {
    dispatch(feedbackReport());
  };

  const exportAppointments = () => {
    dispatch(appointmentsReport());
  };

  const exportConsultations = () => {
    dispatch(consultationReport());
  };

  const exportOrders = () => {
    dispatch(exportPlantOrders());
  };

  const exportFeed = () => {
    dispatch(feedReport());
  };

  const exportRegions = () => {
    dispatch(regionsReport());
  };

  const exportUninstalled = () => {
    dispatch(uninstalledReport());
  };

  const exportDigitalRegistrationsReport = () => {
    dispatch(digitalRegistrationsReport());
  };

  const exportLoanRequestReport = () => {
    dispatch(loanRequestReport());
  };
  const exportDeregistrationRequestsReport = () => {
    dispatch(deregistrationRequestsReport());
  };
  const exportNewMccFarmersReport = () => {
    dispatch(generateReportForMcc());
  };
  const exportHnlManualIndents = () => {
    dispatch(exportRegionalHeadManualIndent({
      type: 'rhApprovedIndents',
      flag: 'export',
    }));
  };
  const arrayOfAdminReports = [
    {
      id: 0,
      name: 'Farmer Registration Report',
      action: exportFarmers,
    },
    {
      id: 1,
      name: 'Farmer Profile',
      action: exportFarmerProfiling,
    },
    {
      id: 2,
      name: 'Appointments Report',
      action: exportAppointments,
    },
    {
      id: 3,
      name: 'Doctor Prescription details Report',
      action: exportConsultations,
    },
    {
      id: 4,
      name: 'Cattle Report',
      action: exportCattle,
    },
    {
      id: 5,
      name: 'Milking Details Report',
      action: exportMilkSlips,
    },
    {
      id: 6,
      name: 'Feedback Report',
      action: exportFeedback,
    },
    {
      id: 7,
      name: 'Feed Report',
      action: exportFeed,
    },
    {
      id: 8,
      name: 'Orders Report',
      action: exportOrders,
    },
    {
      id: 9,
      name: 'MCC Region Report',
      action: exportRegions,
    },
    {
      id: 10,
      name: 'Uninstalled users',
      action: exportUninstalled,
    },
    {
      id: 11,
      name: 'Digital Registrations',
      action: exportDigitalRegistrationsReport,
    },
    {
      id: 12,
      name: 'Farmer Loan Reports',
      action: exportLoanRequestReport,
    },
    {
      id: 13,
      name: 'Mcc Farmers Report',
      action: exportNewMccFarmersReport,
    },
  ];
  if (role === 'admin') arrayOfAdminReports.push({ id: 14, name: 'HNL Manual Indents', action: exportHnlManualIndents });
  if (canAccessDeregistrationRequests) {
    arrayOfAdminReports.push({
      id: 15,
      name: 'Deregistration Requests',
      action: exportDeregistrationRequestsReport,
      viewLink: '/admin/farmer-deregistration-requests',
    });
  }
  const arrayOfHnlAdminReports = [
    {
      id: 0,
      name: 'Farmer Registration Report',
      action: exportFarmers,
    },
    {
      id: 1,
      name: 'Appointments Report',
      action: exportAppointments,
    },
    {
      id: 2,
      name: 'Doctor Prescription details Report',
      action: exportConsultations,
    },
    {
      id: 3,
      name: 'Cattle Report',
      action: exportCattle,
    },
    {
      id: 4,
      name: 'Feedback Report',
      action: exportFeedback,
    },
    {
      id: 5,
      name: 'Feed Report',
      action: exportFeed,
    },
    {
      id: 6,
      name: 'Uninstalled users',
      action: exportUninstalled,
    },
    {
      id: 7,
      name: 'HNL Manual Indents',
      action: exportHnlManualIndents,
    },
  ];
  return (
    <>
      <div className="reports">
        <div className="row">
          <div className="col-12">
            <div className="heading">
              <p className="heading__title">
                All Reports
              </p>
            </div>
          </div>
        </div>
        <div className="table-container">
          <div className="row center">
            <div className="col-12">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Report Name</th>
                    <th>View</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  { role === 'admin' || role === 'ea_pi' || role === 'regional_pi'
                    ? arrayOfAdminReports?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{index + 1}</td>
                        <td>{item?.name}</td>
                        <td>
                          {item?.viewLink ? (
                            <Link to={item.viewLink} className="table__button primary">
                              <FontAwesomeIcon icon={faEye} className="table__button__icon" />
                              View
                            </Link>
                          ) : '-'}
                        </td>
                        <td>
                          <button type="button" className="table__button green" onClick={item?.action}>
                            <FontAwesomeIcon icon={faFileExcel} className="table__button__icon" />
                            Export
                          </button>
                        </td>
                      </tr>
                    )) : arrayOfHnlAdminReports?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{index + 1}</td>
                        <td>{item?.name}</td>
                        <td>-</td>
                        <td>
                          <button type="button" className="table__button green" onClick={item?.action}>
                            <FontAwesomeIcon icon={faFileExcel} className="table__button__icon" />
                            Export
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <LoadingModal
        show={isExporting || isExportingOrders || isExportingRegions || isExportingProducts}
      />
    </>
  );
};

export default Reports;
